import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { QueryParameter } from "@idw-types/common";
import { ExportAssertionFraudResult } from "@idw-types/data/export-assertion-fraud-result";

export const exportAssertionFraudRequest = async (
    queryParameters: Array<QueryParameter>
): Promise<{ data: Array<ExportAssertionFraudResult>, error: any }> => {
    const route = apiRoutes.reports.assertionFraud.export;

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error };
};